/*************************** 产品级vant组件按需引入 ***************************/
import Vue from 'vue';
// vant本地引用图标资源
import 'vant/lib/icon/local.css';
import PublicBlank from '@/components/common/PublicBlank';
import GlobalMask from '@/components/common/GlobalMask';

import {
    IndexBar,
    IndexAnchor,
    Steps,
    Step,
    Card,
    Popup,
    Dialog,
    Tab,
    Tabs,
    Collapse,
    CollapseItem,
    Checkbox,
    CheckboxGroup,
    SubmitBar,
    Col,
    Row,
    Icon,
    Overlay,
    Divider,
    RadioGroup,
    Radio,
    Picker,
    Button,
    DatetimePicker,
    Cell,
    CellGroup,
    Field,
    Form,
    List,
    Notify,
    ActionSheet,
    Tag,
    Toast,
    Empty,
    Uploader,
    Sidebar,
    SidebarItem,
    Tabbar,
    TabbarItem,
    Swipe,
    SwipeItem,
    Lazyload,
    ImagePreview,
    Area,
    Pagination,
    Search,
    DropdownMenu,
    DropdownItem,
    Switch,
    Grid,
    GridItem,
    Image,
    Circle,
    Calendar,
    Rate,
    Image as VanImage,
    NavBar,
    PullRefresh,
    Loading,
    CountDown
} from 'vant';

// 重写信息提示样式
Vue.prototype.$notify_err = message =>
    Notify({
        type: 'danger',
        background: 'red',
        message: message,
        duration: 5000,
        className: 'notify-err'
    });

// 重写信息提示样式
Vue.prototype.$notify_war = message =>
    Notify({
        type: 'warning',
        message: message,
        duration: 5000
    });

// 重写信息提示样式
Vue.prototype.$toast_err = message =>
    Toast({
        // icon: window.config.resourceServer + '/images/icon/share_logo.png',
        type: 'fail',
        message: message,
        duration: 5000
        // className: 'toast-err'
    });

// 清除toast遮罩this.$cls()
Vue.prototype.$cls = function() {
    Toast.clear();
};

// vant加载动画
Vue.prototype.$loading = function(message) {
    if (typeof message === 'string') {
        this.$toast.loading({ message, forbidClick: true, overlay: true, duration: 0 });
    } else {
        this.$toast.loading({ ...message, forbidClick: true, overlay: true, duration: 0 });
    }
};

// vant消息
Vue.prototype.$message = function(message) {
    if (typeof messsage == 'string') {
        this.$toast({ message, forbidClick: true, overlay: true });
    } else {
        this.$toast({ ...message, forbidClick: true, overlay: true });
    }
};

Vue.prototype.$previewImage = function(props) {
    ImagePreview(props);
};

Vue.use(IndexBar);
Vue.use(IndexAnchor);
//app
Vue.use(VanImage);
Vue.use(NavBar);
Vue.use(PullRefresh);
Vue.use(Loading);
Vue.use(Step);
Vue.use(Steps);

Vue.component('PublicBlank', PublicBlank);
Vue.component('GlobalMask', GlobalMask);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(SubmitBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(Overlay);
Vue.use(Divider);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Picker);
Vue.use(Button);
Vue.use(DatetimePicker);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Form);
Vue.use(List);
Vue.use(Notify);
Vue.use(ActionSheet);
Vue.use(Tag);
Vue.use(Toast);
Vue.use(Empty);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(ImagePreview);
Vue.use(Area);
Vue.use(Pagination);
Vue.use(Card);
Vue.use(Search);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Image);
Vue.use(Circle);
Vue.use(Calendar);
Vue.use(Rate);
Vue.use(CountDown);
